(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["audelvyn-catalog"] && !Shopify.designMode) return;
  try {
    
function initAudelvynCatalog(){document.querySelectorAll('[data-av-catalog]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-av-filter]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-av-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-av-category]').forEach(card=>{card.hidden=button.dataset.avFilter!=='all'&&card.dataset.avCategory!==button.dataset.avFilter;});}));});}initAudelvynCatalog();document.addEventListener('shopify:section:load',initAudelvynCatalog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
